// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\ActivityRuleResponse

import { BookingRuleType } from './enums.gen';

export type ActivityRuleApiResponse = {
	type: BookingRuleType.Activity;
	activityIds: Array<string> | null;
};

export type ActivityRule = {
	type: BookingRuleType.Activity;
	activityIds: Array<string> | null;
};

export function hydrateActivityRule(data: ActivityRuleApiResponse): ActivityRule {
	return { ...data };
}